import { useSprintFetch } from "./useSprintFetch";

export const useAuthorizedFetch = () => useSprintFetch({ isPublic: false });
